<template>
  <template v-if="$slots.calculation">
    <div>
      <div class="policy-card">
        <div class="px-3 py-2">
          <div class="d-flex flex-row w-100">
            <slot name="calculation"></slot>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-if="$slots.fields">
  <div class="policy-card min-w-0">
    <div class="policy-card__panel d-flex flex-column min-w-0">
      <div class="row g-3 mx-0 w-100 min-w-0">
        <slot name="fields"></slot>
      </div>
    </div>
  </div>
  </template>
  <template v-if="$slots.additionalPanel">
    <slot name="additionalPanel"></slot>
  </template>
</template>

<script>
export default {
  name: 'PolicyBpmCard',
}
</script>
